import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledToggleSwitch = styled.span`
  ${rtl`
display:flex;
justify-content:center;
margin-bottom:${toRem(20)};
margin-top:${toRem(12)};
@media ${theme.mediaQuery.mobileOnly} {
    margin-top:${toRem(27)};
}
@media ${theme.mediaQuery.desktop} {
    margin-bottom:${toRem(4)};
}
@media ${theme.mediaQuery.tablet} {
    margin-bottom:${toRem(4)};
}
.first-btn {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  height:${toRem(40)};
  border: ${toRem(1)} solid ${theme.color['close-silver']};
  border-right:0;
  letter-spacing: ${toRem(1.3)};
}
.second-btn{
  margin-left:${toRem(-2)};
  letter-spacing:${toRem(1.3)};
  border-top-left-radius: 0px !important;
  border: ${toRem(1)} solid ${theme.color['close-silver']};
  border-left:0;
  border-bottom-left-radius: 0px !important;
  height:${toRem(40)};
}

.active-btn {
 &:hover {
    height:${toRem(40)};
    border-color: #c4c4c4;
  }
}
.m-button-secondary:hover{
  border-color: #c4c4c4;
}

`}
`;
